module.exports = __webpack_public_path__ + "static/img/bg28.3d5aac7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/bg28.jpg
// module id = PYI4
// module chunks = 1